import axios from 'axios';
import { serverUrl } from '../../server';
import Cookies from 'js-cookie';

const token = Cookies.get('jwt')

export function getBenne(id) {
  return axios.get(`${serverUrl}/api/benne/getbenne/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => response.data)
    .catch(error => {
      console.error(error);
      throw error;
    });
}

export function getBennes() {
  var prestataire_id = -1
  if(arguments.length > 0) { prestataire_id = arguments[0]; }
  return axios.post(`${serverUrl}/api/benne/getbennes`, {prestataire_id: prestataire_id}, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => response.data.bennes)
    .catch(error => {
      console.error(error);
      throw error;
    });
}

export function updateBenne(id, data) {
  return axios.put(`${serverUrl}/api/benne/updatebenne/${id}`, data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => response.data)
    .catch(error => {
      console.error(error);
      throw error;
    });
}

export function deleteBenne(id) {
  return axios.delete(`${serverUrl}/api/benne/deletebenne/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => response.data)
    .catch(error => {
      console.error(error);
      throw error;
    });
}

export function getBennesByPrestataire(prestataire_id) {
  return axios.get(`${serverUrl}/api/benne/getbennebyprestataire/${prestataire_id}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => response.data.bennes)
    .catch(error => {
      console.error(error);
      throw error;
    });
} 

export function countBennes() {
  return axios.get(`${serverUrl}/api/benne/countbennes`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => response.data.total)
    .catch(error => {
      console.error(error);
      throw error;
    });
}
